import { useCallback, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'

import useI18n from 'hooks/useI18n'
import useNotificationCenter from 'hooks/useNotificationCenter'
import { getPortalConfig, isLitePath } from 'utils/portal'

function notificationRoute(pathname) {
    if (pathname.startsWith('/mvu-accelerator')) return getPortalConfig('accelerator').notificationsRoute
    if (isLitePath(pathname)) return getPortalConfig('essentials').notificationsRoute
    return getPortalConfig('universe').notificationsRoute
}

export default function useController() {
    const history = useHistory()
    const location = useLocation()
    const { t } = useI18n()
    const [markingAll, setMarkingAll] = useState(false)
    const {
        notifications,
        unreadCount,
        loading,
        loaded,
        error,
        loadNotifications,
        markNotificationRead,
        markAllRead,
    } = useNotificationCenter()

    const openNotification = useCallback(async notification => {
        await markNotificationRead(notification)
        history.push(`${notificationRoute(location.pathname)}/${notification.id}`)
    }, [history, location.pathname, markNotificationRead])

    const handleMarkAllRead = useCallback(async () => {
        setMarkingAll(true)
        const updated = await markAllRead()
        setMarkingAll(false)

        if (!updated) {
            toast.error(t('notifications_update_error'))
        }
    }, [markAllRead, t])

    return {
        notifications,
        unreadCount,
        loading,
        loaded,
        error,
        markingAll,
        retry: loadNotifications,
        openNotification,
        markAllRead: handleMarkAllRead,
        t,
    }
}
